<div
  *ngIf="partners && partners.length"
  fxLayout="column"
  fxLayout.gt-xs="row"
  fxLayoutAlign="center center"
  fxLayoutAlign.gt-xs="center start"
>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center center"
    class="partners-right partners0"
  >
    <div
      *ngFor="let i of [0, 1, 2];"
      class="partner-item"
      (click)="openPartnerModal(partners[i])"
      appPositionAwareCover
    >
      <div
        class="overlay"
      >
      </div>
      <button
        mat-raised-button
        color="main-color"
        class="overlay-link"
      >
        {{ 'buttons.see_more' | translate }}
      </button>
      <div class="partner-info">
        <span class="partner-role">{{ partners[i].role }}</span>
        <img
          [src]="partners[i].image.url"
          alt="romanescupark partener"
          class="partner-image"
        >
        <span class="partner-name">{{ partners[i].title }}</span>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/partners/partners.component.html